import { MessageBar, MessageBarType, makeStyles, mergeStyles } from "@fluentui/react";
import { useState } from "react";

interface MessageBarSuccess {
  text?: string;
  showIcon?: boolean;
  type:MessageBarType;
  intro:string

}
const useStyles = makeStyles({
  compact: {
    width: "100%",
  },
});
const compactStyle = mergeStyles({
    margin: "0",
    padding: "8px 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  });


export const MessageBarComponent = (props: MessageBarSuccess) => {
  const [isView, setIsView] = useState<boolean>(true);
  const styles = useStyles();

  const close = () => {
    if (isView) {
      setIsView(false);
    }
  };

  return (
    <>
       {isView && (
        <div className={compactStyle}>
          <MessageBar
            messageBarType={props.type}
            isMultiline={true}
            onDismiss={close}
            dismissButtonAriaLabel="Cerrar"
          >
            <strong>{props.intro}: </strong>
            {props.text}
          </MessageBar>
        </div>
      )}
    </>
  );
};